import { memo, useEffect, useState, useRef } from 'react'
import CountDown from '@/components/CountDown/CountDown'
import ScaledText from '@/components/ScaledText/ScaledText'
import SvgIcon from '@/components/SvgIcon/SvgIcon'
import { useAbortableRequest } from '@/hooks/useAbortableRequest'
import { useUserAccount } from '@/hooks/useUserAccount'
import { Modal, QRCode, message } from 'antd'
import './PayCode.less'
// 支付方式配置
const PAYMENT_METHODS = [
  { label: '微信', icon: 'icon-weixinzhifu' }
  // { label: '支付宝', icon: 'icon-alipay' }
] as const

// 组件属性类型定义
interface PayCodeProps {
  visible: boolean
  className?: string
  onCancel: () => void
  price?: number
  originalPrice?: number
  countdownPeriod?: number
  diff?: number
  items?: any[]
}

const PayCode = ({ visible, className, onCancel, price, originalPrice, diff, countdownPeriod = 1, items }: PayCodeProps) => {
  const timer = useRef<any>(null)
  const { sendRequest, abort } = useAbortableRequest()
  const { fetchUserAccount } = useUserAccount()
  const [codeUrl, setCodeUrl] = useState()

  useEffect(() => {
    if (visible && items) {
      pay()
    }
    return () => {
      clearTimeout(timer.current)
    }
  }, [visible, items])

  const pay = async () => {
    const result: any = await sendRequest({
      method: 'post',
      url: 'pay',
      data: { items }
    })
    if (result?.res) {
      setCodeUrl(result?.res?.data?.code_url)
      pay_result(result?.res?.data?.out_trade_no)
    }
  }

  const pay_result = async (out_trade_no: number) => {
    try {
      const result: any = await sendRequest(
        {
          method: 'post',
          url: 'pay_result',
          data: { out_trade_no }
        },
        { showTip: false }
      )
      if (result?.res) {
        message.success('支付成功')
        fetchUserAccount()
        clearTimeout(timer.current)
        handleCancel()
      } else {
        clearTimeout(timer.current)
        timer.current = setTimeout(() => {
          pay_result(out_trade_no)
        }, 2000)
      }
    } catch (error: any) {
      // 如果是 AbortError，说明请求被取消，不需要重试
      if (error.name === 'AbortError') {
        console.log('支付结果查询被取消')
        return
      }
      clearTimeout(timer.current)
      timer.current = setTimeout(() => {
        pay_result(out_trade_no)
      }, 2000)
    }
  }
  const handleCancel = () => {
    abort()
    clearTimeout(timer.current)
    if (onCancel) onCancel()
  }
  return (
    <Modal
      wrapClassName={`${className || ''} PayCode-container`}
      open={visible}
      onCancel={handleCancel}
      title=''
      footer={null}
      centered
      width={350}
      height={500}
    >
      <div className='wrapper'>{codeUrl && <QRCode value={codeUrl || '-'} />}</div>
      <ul>
        {PAYMENT_METHODS.map((item, index) => (
          <li key={`${item.label}-${index}`}>
            <SvgIcon href={item.icon} />
          </li>
        ))}
      </ul>
      <p>请使用微信扫一扫支付</p>
      <div className='info'>
        <label>合计</label>
        <div className='noePrice'>
          ¥<span>{price}</span>
        </div>
        <div className='youhui'>
          <span>立省 ¥{diff}</span>
          <span>原价 ¥{originalPrice}</span>
        </div>
      </div>
      <CountDown showDays={false} startText='本次优惠' period={countdownPeriod} />
      <ScaledText className='desc' size={10}>
        支付前请确认：接受AI模型生成内容的局限性和可能存在的误差，将生成的内容仅作为范文参考，确认支付后不支持任何形式退款。
      </ScaledText>
    </Modal>
  )
}

export default memo(PayCode)
